import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Message} from 'semantic-ui-react';
import moment from 'moment-jalaali';

function ConsultPackageWarning(props) {
  return (
    <Message warning className='text-center'>
      <p>
        داوطلب گرامی زمان بسته مشاوره شما در تاریخ
        &nbsp;
        {moment(props.expireTime).format('dddd jYYYY/jM/jD')}
        &nbsp;
        به اتمام می‌رسد.
      </p>
      <p>
        لطفا با مراجعه به لینک
        &nbsp;
        <Link to='/consult-packages'>بسته‌های مشاوره</Link>
        &nbsp;
        نسبت به تمدید بسته مشاوره خود اقدام فرمایید.
      </p>
    </Message>
  );
}

ConsultPackageWarning.propTypes = {
  expireTime: PropTypes.string.isRequired
};

export default ConsultPackageWarning;
